import { render, staticRenderFns } from "./mainRecommend.vue?vue&type=template&id=d475ec96"
import script from "./mainRecommend.vue?vue&type=script&lang=js"
export * from "./mainRecommend.vue?vue&type=script&lang=js"
import style0 from "./mainRecommend.vue?vue&type=style&index=0&id=d475ec96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.47.0_supports-color@_e2va3oitd2br7adsazclseazuu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports